/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC } from 'react';
import { ProductCatalogueForm } from 'components/Forms/ProductCatalogueForm/ProductCatalogueForm';

export const AddProductPopup: FC = function () {
  return <ProductCatalogueForm />;
};
